module.exports = __webpack_public_path__ + "static/media/job-listing-banner.44d9c72d.jpg";